import React from "react";
import NumberFormat from "react-number-format";
import PromoCodesTable from "./PromoCodesTable";
import StudentsPricingDetails from "./StudentsPricingDetails";
import ValidatedInput from "../../../shared/ValidatedInput";
import { TripTypes } from "../../TripEventConsts";

export default function EventPricing(props) {
  const {
    event: {
      attendeeActualCostChaperone,
      attendeeActualCostShliach,
      attendeeFeeChaperone,
      attendeeFeeShliach,
      enrollmentFee,
      hasStartedShluchimEnrollment,
      hasStudentRegistrations,
      isTravelTrip,
      promoCodes,
      rewardCreditValue,
      type,
    },
    onChange,
    onChangeEvt,
    submitAttempted,
    track: {
      earlyBirdStudentDeadline,
      earlyBirdStudentPrice,
      regularStudentPrice,
      studentDepositAmount,
    },
    trackFieldPrefix,
  } = props;

  const isJewishUTrip = type === TripTypes.JewishU;

  return (
    <React.Fragment>
      <div className="program-settings-page-section">
        <p className="program-settings-page-title xxl-text fw-500">Pricing</p>
        {hasStartedShluchimEnrollment && (
          <span className="accent-text">
            * Pricing changes will not affect existing enrollments or
            registrations.
          </span>
        )}
      </div>

      {!isTravelTrip && (
        <div className="program-settings-page-section">
          <p className="medium-text fw-700 mb-16">Shluchim</p>
          <div className="two-column-grid pricing-two-column-grid">
            <RequiredNumberInput
              value={enrollmentFee}
              onChange={onChange}
              name="enrollmentFee"
              submitAttempted={submitAttempted}
              label="Enrollment Fee"
            />

            {/* spacer so the fields below line up nicely */}
            <div />

            <RequiredNumberInput
              value={attendeeFeeShliach}
              onChange={onChange}
              name="attendeeFeeShliach"
              submitAttempted={submitAttempted}
              label="Shliach Attendee Fee"
            />

            <RequiredNumberInput
              value={attendeeActualCostShliach}
              onChange={onChange}
              name="attendeeActualCostShliach"
              submitAttempted={submitAttempted}
              label="Shliach Actual Cost"
            />

            <RequiredNumberInput
              value={attendeeFeeChaperone}
              onChange={onChange}
              name="attendeeFeeChaperone"
              submitAttempted={submitAttempted}
              label="Chaperone Attendee Fee"
            />

            <RequiredNumberInput
              value={attendeeActualCostChaperone}
              onChange={onChange}
              name="attendeeActualCostChaperone"
              submitAttempted={submitAttempted}
              label="Chaperone Actual Cost"
            />
          </div>
        </div>
      )}

      <StudentsPricingDetails
        onChange={onChange}
        onChangeEvt={onChangeEvt}
        hasStudentRegistrations={hasStudentRegistrations}
        isJewishUTrip={isJewishUTrip}
        isTravelTrip={isTravelTrip}
        priceDetails={{
          earlyBirdStudentDeadline,
          earlyBirdStudentPrice,
          regularStudentPrice,
          rewardCreditValue,
          studentDepositAmount,
        }}
        trackFieldPrefix={trackFieldPrefix}
        submitAttempted={submitAttempted}
      />

      <PromoCodesTable
        isJewishUTrip={isJewishUTrip}
        isTravelTrip={isTravelTrip}
        onChange={onChange}
        promoCodes={promoCodes}
      />
    </React.Fragment>
  );
}

function RequiredNumberInput({
  value,
  onChange,
  name,
  label,
  submitAttempted,
}) {
  return (
    <>
      <div className="flex flex-align-center">
        <label className="input-label">{label}</label>
        <ValidatedInput
          input={
            <NumberFormat
              allowNegative={false}
              className="dollar-input"
              onValueChange={({ floatValue }) =>
                onChange(name, floatValue >= 0 ? floatValue : "")
              }
              decimalScale={2}
              thousandSeparator={true}
            />
          }
          name={name}
          required
          showRequired={submitAttempted && value !== 0}
          value={value}
        />
      </div>
    </>
  );
}
